import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-layout-layout-vertical-icon',
  templateUrl: './layout-layout-vertical.component.html'
})
export class LayoutLayoutVerticalComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
